import type { RootState } from '~/reducers';

export const isSubNavActive = (state: RootState) => state.vendors.menu.activeMenu;
